import React from 'react';

import IconButton from 'components/common/IconButton';
import UploadCandidates from 'components/uploads/UploadCandidates';

/**
 * @component CandidatesTableActions
 * @description Componente de acciones que se muestra sobre la tabla de candidatos.
 * Permite crear un nuevo candidato, exportar la información o importar desde archivo.
 * 
 * @param {Object} props
 * @param {Function} props.handleOpen - Función para abrir el modal de creación de nuevo candidato.
 * @param {Function} props.handleLoad - Función para manejar la carga de candidatos desde archivo.
 * 
 * @returns {JSX.Element} Acciones de tabla de candidatos.
 * 
 * @example
 * <CandidatesTableActions handleOpen={handleOpenModal} handleLoad={handleSubmitCandidates} />
 */
const CandidatesTableActions = ({ handleOpen, handleLoad }) => {
    return (
        <div id="orders-actions">
            {/* Botón para agregar nuevo candidato */}
            <IconButton
                variant="falcon-default"
                size="sm"
                icon="plus"
                transform="shrink-3"
                className="mx-2"
                iconAlign="middle"
                onClick={handleOpen}>
                <span className="d-none d-sm-inline-block d-xl-none d-xxl-inline-block ms-1">
                    Nuevo
                </span>
            </IconButton>
            {/* Componente de carga de candidatos */}
            <UploadCandidates onSubmitFile={handleLoad} />
        </div>
    );
};

export default CandidatesTableActions;